// Applies environment-aware branding to the document: the tab title gets a
// DEV/LOCAL prefix, and on dev/local the tab favicon is recolored to the
// environment hue. Prod is left untouched (static /favicon.svg, brand blue).

import { ENV_FAVICON_HEX, getAppTitle, getEnvironment } from './environment';

export async function applyEnvBranding(): Promise<void> {
  document.title = getAppTitle();

  const env = getEnvironment();
  if (env === 'prod') return; // keep the static favicon.svg as-is

  const hex = ENV_FAVICON_HEX[env];
  try {
    const svg = await (await fetch('/favicon.svg')).text();
    // favicon.svg fills brand blue in light mode and white in dark mode; force
    // both to the environment hue so the tab icon stays the env color always.
    const recolored = svg.replace(/#4E73A6/g, hex).replace(/#FFFFFF/g, hex);
    const href = `data:image/svg+xml,${encodeURIComponent(recolored)}`;

    let link = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/svg+xml';
    link.href = href;
  } catch {
    // Network hiccup fetching the source SVG — leave the default favicon.
  }
}
